export const changeGroupAdminNameToOrgAdmin = (raw: string | undefined | null): string => {
  if (!raw) return '';
  return raw.replace(/Group Admin/g, 'Org Admin');
};

export const changeGroupNameToOrganization = (raw: string | undefined | null): string => {
  if (!raw) return '';
  return raw.replace(/Group/g, 'Organization');
};
